import React from "react";

/**
 * Renders a task description, auto-converting newline-separated lines into a
 * bulleted list. Single-line descriptions stay as plain text so simple notes
 * don't get an unnecessary bullet.
 *
 * Used by the admin TaskItem (expanded view), the public quote page, and
 * anywhere else a multi-line description is shown.
 */
const TaskDescription = ({ text, className = "", bulletClassName = "" }) => {
  if (!text) return null;
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return null;
  if (lines.length === 1) {
    return <span className={className}>{lines[0]}</span>;
  }
  return (
    <ul className={`list-disc pl-5 space-y-0.5 ${bulletClassName}`}>
      {lines.map((line, i) => (
        <li key={i} className={className}>{line}</li>
      ))}
    </ul>
  );
};

export default TaskDescription;
